'use strict';
  
angular.module('atex.dam').directive( 'damTreeview', ['$compile', function( $compile ) {
    
  return {
    
    restrict: 'E',
    
    scope: {
      model: '=',
      nodeLabel: '@',
      nodeId: '@',
      nodeChildren: '@',
      selectedCallback: '&',
      dropCallback: '&',
      expandCallback: '&',
      listCallback: '&',
      hideRoot: '=',
      listAfterSelection: '=',
      currentNode: '=',
      orderingEnabled: '=?'
	  },
    
	  link: function ( scope, element, attrs ) {

      scope.orderingEnabled = (scope.orderingEnabled !== false);

      var listAfterSelection = !!scope.listAfterSelection;
      
      if (!scope.currentNode) {
        scope.currentNode = {};
      }
      
      scope.nodeSelected = function(node) {
        if (!listAfterSelection || (scope.currentNode && scope.currentNode === node)) {
          // callback
          if (node && scope.listCallback) {
            scope.listCallback({
              node : node
            });
          }
          if (listAfterSelection) {
            return;
          }
        }
        // remove highlight from previous node
        if (scope.currentNode && scope.currentNode.selected) {
          scope.currentNode.selected = undefined;
        }
        // set new current node
        scope.currentNode = node;
        // set highlight to current node
        if (scope.currentNode) {
          scope.currentNode.selected = 'selected';
        }
        // callback
        if (scope.selectedCallback) {
          scope.selectedCallback({
            node : node
          });
        }
        if (scope.currentNode && scope.currentNode.collapsed) {
          scope.toggleNode(node);
        }
      };
      
      scope.droppedOnNode = function(node, event) {
        // callback
        if (scope.dropCallback) {
          scope.dropCallback({
            node : node,
            event: event
          });
        }
      };
      
      scope.nodeExpanded = function(node) {
        // callback
        if (scope.expandCallback) {
          scope.expandCallback({
            node : node
          });
        }
      };

      scope.nodeCollapsed = function(node) {
        if (scope.currentNode!==node) {
          scope.nodeSelected(undefined);
        }
      };

      scope.toggleNode = function(node, forceOpen) {
        if (forceOpen) {
          var wasCollapsed = node.collapsed;
          node.collapsed = false;
          if (wasCollapsed) {
            scope.nodeExpanded(node);
          }
          return;
        }
        node.collapsed = !node.collapsed;
        if (node.collapsed === false) {
          scope.nodeExpanded(node);
        } else {
          scope.nodeCollapsed(node);
        }
      };

      var template =
        '<dam-treeview-inner data-model="model" data-node-id="' + scope.nodeId + '" data-node-label="' + scope.nodeLabel +'" data-node-children="' + scope.nodeChildren + '">' +
        '</dam-treeview-inner>';

      element.html('').append( $compile( template )( scope ) );
    }
	  
	};
	
}])

.directive( 'damTreeviewInner', ['$compile', function( $compile ) {
  
  return {
    
    restrict: 'E',
    
    link: function ( scope, element, attrs ) {
      
      var model = attrs.model;
      var nodeId = attrs.nodeId || 'id';
      var nodeLabel = attrs.nodeLabel || 'label';
      var nodeChildren = attrs.nodeChildren || 'children';

      var template =
        '<ul ng-class="{\'hide-root\':hideRoot===true}" >' +
          '<li data-ng-repeat="node in ' + model + (scope.orderingEnabled ? (' | orderBy:\'' + scope.nodeLabel + '\'">') :  ('">')) +
            '<tree-node></tree-node>' +
            '<dam-treeview-inner data-ng-if="!node.collapsed" data-model="node.' + nodeChildren + '" data-node-id="' + nodeId + '" data-node-label="' + nodeLabel + '" data-node-children="' + scope.nodeChildren + '"></dam-treeview-inner>' +
          '</li>' +
        '</ul>';

      element.html('').append( $compile( template )( scope ) );
    }

  };
}])

.directive( 'treeNode', ['$compile', '$timeout', 'ApplicationConfigurationService', function( $compile, $timeout, ApplicationConfigurationService ) {
  var timeoutOnDragEnterTreeView = 1000;
  ApplicationConfigurationService.getConfigurationFor(['timeoutOnDragEnterTreeView']).then(function(options) {
    if (options) {
      timeoutOnDragEnterTreeView = options;
    }
  });
  
  var setupDnD = function(element, scope, node) {
    var _scope = scope;
    var _node = node;
    
    var el = element[0];
    
    // Setup dragover
    element.on('dragover', function(e) {
      e.originalEvent.dataTransfer.dropEffect = 'move';
      // allows us to drop
      if (e.preventDefault) {
        e.preventDefault();
      }
      this.classList.add('over');
      return false;
    });
    
    // Setup dragenter and dragleave
    element.on('dragenter', function(e) {
      if (e.preventDefault) {
        e.preventDefault();
      }
      //console.log("dragenter... " + this.children[0].innerText);
      this.classList.add('over');
      $timeout(function() {
        _scope.toggleNode(_node, true);
        _scope.$digest();
        return false;
      }, timeoutOnDragEnterTreeView);
    });
    element.on('dragleave', function() {
      //console.log("dragleave... " + this.children[0].innerText);
      this.classList.remove('over');
      return false;
    });
    
    // Setup drop
    element.on('drop', function(e) {
      //console.log("drop... " + this.children[0].innerText);
      // Stops some browsers from redirecting.
      if (e.stopPropagation) {
        e.stopPropagation();
      }
      e.preventDefault();
      this.classList.remove('over');
      
      _scope.droppedOnNode(_node, e);
      return false;
    });
  };
  
  return {
    
    restrict: 'AE',
    
    link: function ( scope, element, attrs ) {
      
      var folderClosedIconClass = scope.node.folderClosedIconClass ? scope.node.folderClosedIconClass : "fa fa-folder-o";
      var folderOpenIconClass = scope.node.folderOpenIconClass ? scope.node.folderOpenIconClass : "fa fa-folder-open-o";
      
      var template =
        '<span ng-hide="node.isRoot && hideRoot">' +
          '<i class="' + folderClosedIconClass + '" data-ng-if="node.collapsed" data-ng-click="toggleNode(node)"></i>' +
          '<i class="' + folderOpenIconClass + '" data-ng-if="!node.collapsed" data-ng-click="toggleNode(node)"></i>' +
          '<span data-ng-class="node.selected" data-ng-click="nodeSelected(node)">{{node.' + scope.nodeLabel + '}}</span>' +
        '</span>';
      
      element.html('').append( $compile( template )( scope ) );
      
      setupDnD(element, scope, scope.node);
    }
  
  };
  
}]);
	
